'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentPaypalAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M38.2905 29.3714L38.6562 27.0392L37.8415 27.0201H33.9515L36.6549 9.8093C36.6634 9.75719 36.6906 9.70881 36.7304 9.67439C36.7703 9.63997 36.8212 9.62109 36.8745 9.62109H43.4337C45.6114 9.62109 47.1141 10.076 47.8986 10.974C48.2664 11.3952 48.5007 11.8355 48.6141 12.3199C48.733 12.8283 48.735 13.4356 48.619 14.1765L48.6106 14.2303V14.7051L48.9784 14.9144C49.2881 15.0794 49.5343 15.2682 49.7231 15.4843C50.0377 15.8446 50.2412 16.3024 50.3272 16.845C50.4161 17.4032 50.3868 18.0675 50.2412 18.8195C50.0734 19.6845 49.8021 20.4379 49.4356 21.0543C49.0987 21.6222 48.6694 22.0934 48.1595 22.4584C47.6728 22.8054 47.0945 23.0687 46.4407 23.2372C45.8071 23.4028 45.0847 23.4864 44.2924 23.4864H43.782C43.417 23.4864 43.0625 23.6184 42.7842 23.855C42.5051 24.0965 42.3205 24.4265 42.2639 24.7874L42.2254 24.9974L41.5792 29.1083L41.55 29.2591C41.5422 29.3069 41.5288 29.3307 41.5092 29.3469C41.4918 29.3616 41.4667 29.3714 41.4423 29.3714H38.2905Z",
          fill: "#28356A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M49.3269 14.2852C49.3075 14.4108 49.285 14.5392 49.2599 14.6712C48.3949 19.1304 45.4355 20.6709 41.656 20.6709H39.7315C39.2693 20.6709 38.8797 21.0078 38.8078 21.4656L37.5434 29.5181C37.4966 29.8188 37.7274 30.0896 38.0294 30.0896H41.4427C41.8467 30.0896 42.1901 29.7948 42.2538 29.3946L42.2873 29.2205L42.9299 25.1258L42.9712 24.9012C43.0341 24.4996 43.3783 24.2046 43.7823 24.2046H44.2928C47.5997 24.2046 50.1885 22.8566 50.9452 18.9556C51.2611 17.326 51.0976 15.9653 50.2612 15.0083C50.0081 14.7198 49.6942 14.4802 49.3269 14.2852Z",
          fill: "#298FC2"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M48.4221 13.9229C48.2898 13.8842 48.1535 13.8492 48.0137 13.8175C47.873 13.7866 47.7291 13.7593 47.5808 13.7353C47.0619 13.6511 46.4933 13.6112 45.8843 13.6112H40.7433C40.6166 13.6112 40.4963 13.6399 40.3888 13.6918C40.1516 13.8063 39.9755 14.0317 39.9328 14.3076L38.839 21.2629L38.8077 21.4656C38.8796 21.0078 39.2692 20.6709 39.7314 20.6709H41.6559C45.4354 20.6709 48.3948 19.1296 49.2598 14.6712C49.2857 14.5393 49.3074 14.4108 49.3268 14.2852C49.108 14.1686 48.871 14.0688 48.6158 13.9839C48.5527 13.9628 48.4877 13.9426 48.4221 13.9229Z",
          fill: "#22284F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M39.9327 14.3077C39.9754 14.0317 40.1515 13.8064 40.3887 13.6927C40.497 13.6406 40.6165 13.6118 40.7432 13.6118H45.8843C46.4933 13.6118 47.0619 13.652 47.5807 13.7361C47.729 13.7599 47.873 13.7875 48.0136 13.8183C48.1535 13.8498 48.2898 13.885 48.422 13.9236C48.4876 13.9432 48.5527 13.9637 48.6163 13.9839C48.8715 14.0689 49.1087 14.1694 49.3275 14.2852C49.5849 12.6374 49.3254 11.5154 48.4381 10.4994C47.4597 9.38078 45.6941 8.9021 43.4347 8.9021H36.8754C36.4139 8.9021 36.0202 9.23899 35.9489 9.69761L33.2169 27.0854C33.163 27.4294 33.4272 27.7397 33.7727 27.7397H37.8222L39.9327 14.3077Z",
          fill: "#28356A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.9646 34.1052H14.1822C13.8549 34.1052 13.5766 34.344 13.5254 34.6685L11.5912 46.9813C11.5528 47.2244 11.7403 47.4433 11.9857 47.4433H14.2688C14.5961 47.4433 14.8744 47.2047 14.9255 46.8796L15.4471 43.5585C15.4975 43.2335 15.7764 42.9947 16.1031 42.9947H17.617C20.7672 42.9947 22.5853 41.4641 23.0603 38.4311C23.2742 37.104 23.0693 36.0615 22.4504 35.3312C21.7707 34.5294 20.5651 34.1052 18.9646 34.1052ZM19.5161 38.6024C19.2546 40.3254 17.9434 40.3254 16.6757 40.3254H15.9539L16.4603 37.1075C16.4904 36.913 16.6581 36.7698 16.854 36.7698H17.1848C18.0484 36.7698 18.863 36.7698 19.284 37.2641C19.5351 37.5589 19.6119 37.997 19.5161 38.6024Z",
          fill: "#28356A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M33.3821 38.4538H31.0919C30.8968 38.4538 30.7282 38.5969 30.6982 38.7914L30.5968 39.4345L30.4367 39.2015C29.941 38.4789 28.8353 38.2374 27.7319 38.2374C25.2011 38.2374 23.0396 40.162 22.6187 42.8616C22.3999 44.2082 22.711 45.496 23.4719 46.3939C24.1698 47.2195 25.1684 47.5637 26.3563 47.5637C28.3956 47.5637 29.5261 46.2472 29.5261 46.2472L29.4241 46.8862C29.3857 47.1305 29.5731 47.3495 29.8172 47.3495H31.8799C32.208 47.3495 32.485 47.1108 32.5367 46.7857L33.7744 38.9157C33.8136 38.6734 33.6267 38.4538 33.3821 38.4538ZM30.1897 42.9291C29.9688 44.2426 28.9305 45.1245 27.606 45.1245C26.941 45.1245 26.4096 44.9103 26.0682 44.5046C25.7297 44.1016 25.6012 43.5279 25.7088 42.889C25.9152 41.5866 26.971 40.6759 28.2753 40.6759C28.9256 40.6759 29.4542 40.893 29.8025 41.3021C30.1513 41.7157 30.2898 42.2929 30.1897 42.9291Z",
          fill: "#28356A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M45.4029 38.6508H43.1014C42.8819 38.6508 42.6756 38.7603 42.5512 38.9436L39.3771 43.6378L38.0317 39.1267C37.9471 38.8445 37.6877 38.6508 37.3939 38.6508H35.1326C34.8576 38.6508 34.6668 38.9204 34.7541 39.1802L37.2891 46.6491L34.9059 50.0271C34.7185 50.2932 34.9073 50.659 35.2311 50.659H37.5297C37.7479 50.659 37.952 50.5522 38.0757 50.3726L45.73 39.2791C45.9134 39.0138 45.7251 38.6508 45.4029 38.6508Z",
          fill: "#28356A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M53.075 34.1052H48.292C47.9655 34.1052 47.6871 34.344 47.636 34.6685L45.7018 46.9813C45.6634 47.2244 45.8508 47.4433 46.0949 47.4433H48.5493C48.7771 47.4433 48.9722 47.2763 49.0079 47.0488L49.5569 43.5585C49.6073 43.2335 49.8864 42.9947 50.2129 42.9947H51.7262C54.877 42.9947 56.6945 41.4641 57.1701 38.4311C57.3847 37.104 57.1785 36.0615 56.5595 35.3312C55.8805 34.5294 54.6756 34.1052 53.075 34.1052ZM53.6268 38.6024C53.3659 40.3254 52.0547 40.3254 50.7863 40.3254H50.0655L50.5724 37.1075C50.6024 36.913 50.7688 36.7698 50.9653 36.7698H51.2961C52.159 36.7698 52.9744 36.7698 53.3953 37.2641C53.6464 37.5589 53.7226 37.997 53.6268 38.6024Z",
          fill: "#298FC2"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M67.4895 38.4538H65.2008C65.0043 38.4538 64.8372 38.5969 64.8079 38.7914L64.7064 39.4345L64.5456 39.2015C64.0498 38.4789 62.9449 38.2374 61.8414 38.2374C59.3107 38.2374 57.15 40.162 56.7291 42.8616C56.5109 44.2082 56.8206 45.496 57.5813 46.3939C58.2808 47.2195 59.2778 47.5637 60.466 47.5637C62.505 47.5637 63.6358 46.2472 63.6358 46.2472L63.5337 46.8862C63.4953 47.1305 63.6826 47.3495 63.9282 47.3495H65.9903C66.3168 47.3495 66.5952 47.1108 66.6463 46.7857L67.8846 38.9157C67.9224 38.6734 67.735 38.4538 67.4895 38.4538ZM64.2973 42.9291C64.0777 44.2426 63.0378 45.1245 61.7133 45.1245C61.0497 45.1245 60.517 44.9103 60.1755 44.5046C59.8373 44.1016 59.71 43.5279 59.8161 42.889C60.0239 41.5866 61.0783 40.6759 62.3826 40.6759C63.0329 40.6759 63.5616 40.893 63.9098 41.3021C64.2601 41.7157 64.3985 42.2929 64.2973 42.9291Z",
          fill: "#298FC2"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M69.9986 34.4437L68.0358 46.9819C67.9974 47.225 68.1847 47.4439 68.4287 47.4439H70.4021C70.7302 47.4439 71.0084 47.2053 71.0587 46.8802L72.9943 34.568C73.0329 34.3249 72.8454 34.1052 72.6014 34.1052H70.3918C70.1967 34.1058 70.0288 34.2492 69.9986 34.4437Z",
          fill: "#298FC2"
        }
      )
    ]
  }
);
const VpPaymentPaypalAsset = forwardRef(PaymentPaypalAsset);

export { VpPaymentPaypalAsset as default };
